import { render, staticRenderFns } from "./Ui.vue?vue&type=template&id=5885593d&scoped=true"
import script from "./Ui.vue?vue&type=script&lang=js"
export * from "./Ui.vue?vue&type=script&lang=js"
import style0 from "./Ui.vue?vue&type=style&index=0&id=5885593d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885593d",
  null
  
)

export default component.exports